import { mutate } from "swr";

/** SWR cache key for the public library list (`getBooks`). */
export const LIBRARY_BOOKS_KEY = ["books", "library"] as const;

/** Invalidate book-by-id caches and the library list (e.g. after save/update). */
export function revalidateBookCaches(bookId: string): Promise<unknown[]> {
  return Promise.all([
    mutate(
      (key) => Array.isArray(key) && key[0] === "book" && key[1] === bookId,
    ),
    mutate(LIBRARY_BOOKS_KEY),
  ]);
}
